<script setup>
import axios from 'axios'
import { useI18n } from 'vue-i18n'
import RecentlyUpdated from '@/views/new/components/RecentlyUpdated.vue'

const { t } = useI18n()

const ADDRESS_TYPES = {
  1: 'news',
  2: 'announcement'
}

const DEFAULT_PAGE = 1
const DEFAULT_LIMIT = 10

const hostList = ref([])
const hostListId = ref(1)
const hostList_Id = ref(null)
const newsList = ref([])
const page = ref(DEFAULT_PAGE)
const limit = ref(DEFAULT_LIMIT)
const typeNum = ref(0)
const addressID = ref('')
const currentAddressType = ref('')
const categoryLoading = ref(false)
const newsLoading = ref(false)

const currentTypeId = computed(() => {
  return hostList_Id.value || hostList.value[0]?.id || null
})

const detailPath = computed(() => {
  return addressID.value == 1 ? 'news' : 'announcement'
})

const getUrlParam = (name) => {
  return new URLSearchParams(window.location.search).get(name)
}

const getAddressByClass = (classValue) => {
  return ADDRESS_TYPES[classValue] || ADDRESS_TYPES[1]
}

const getCurrentDate = (time) => {
  const timestamp = Number(time)
  if (!timestamp) return '--'

  const date = new Date(timestamp * 1000)
  if (Number.isNaN(date.getTime())) return '--'

  const pad = n => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

const requestClassificationType = async () => {
  const classValue = getUrlParam('Class')
  if (!classValue) return

  addressID.value = classValue
  currentAddressType.value = getAddressByClass(classValue)

  try {
    const { data } = await axios.get(`/console/v1/${currentAddressType.value}/type`)
    hostList.value = data?.data?.list || []
    hostList_Id.value = hostList.value[0]?.id || null

    await requestNewsSubject()
  } catch (error) {
    if (!axios.isCancel(error)) {
      console.error('请求分类失败:', error)
    }
  }
}

const requestNewsSubject = async () => {
  if (!currentAddressType.value || !currentTypeId.value) return

  newsLoading.value = true

  try {
    const params = {
      page: page.value,
      limit: limit.value,
      [`addon_idcsmart_${currentAddressType.value}_type_id`]: currentTypeId.value
    }

    const { data } = await axios.get(`/console/v1/${currentAddressType.value}`, { params })
    const list = data?.data?.list || []

    newsList.value = list.length ? list : null
    typeNum.value = data?.data?.count || 0
  } catch (error) {
    if (!axios.isCancel(error)) {
      console.error('请求新闻主体失败:', error)
      newsList.value = []
      typeNum.value = 0
    }
  } finally {
    newsLoading.value = false
  }
}

const mainClassificationMethod = async (item, index) => {
  if (!item?.id || item.id === hostList_Id.value) return

  page.value = DEFAULT_PAGE
  hostListId.value = index + 1
  hostList_Id.value = item.id
  categoryLoading.value = true

  try {
    await requestNewsSubject()
  } finally {
    categoryLoading.value = false
  }
}

const handlePageChanges = async (pageSize) => {
  limit.value = Number(pageSize) || DEFAULT_LIMIT
  page.value = DEFAULT_PAGE
  await requestNewsSubject()
}

watch(page, (newVal, oldVal) => {
  if (oldVal && newVal !== oldVal) {
    requestNewsSubject()
  }
})

onMounted(requestClassificationType)
</script>

<template>

    <!-- banner图 -->
    <div class="Heziyun-banners">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-banner-title">
                <span>{{ addressID == '1' ? t('news.bannerTitleNews') :
                    t('news.bannerTitleAnnouncement') }}</span>
                <p>
                    {{ t('news.bannerDesc') }}
                </p>
            </div>
        </div>
    </div>

    <!-- 主分类 搜索 标签分类 新闻 新闻总条数 分页 -->
    <div class="Heziyun-mainCategory Heziyun-padding" id="primary">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-flexmin">
                <div class="Heziyun-sideEdge">
                    <!-- 主分类 -->
                    <div class="Heziyun-hostList">
                        <div class="Heziyun-switchingClasses" v-if="hostList.length !== 0">
                            <div class="Heziyun-itemClass" v-for="(item, index) in hostList"
                                :class="{ 'Heziyun-active': index + 1 == hostListId }"
                                @click="mainClassificationMethod(item, index)">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>

                    <!-- 新闻 -->
                    <a-spin :loading="newsLoading" :size="20" :tip="t('news.loading')">

                        <div class="Heziyun-newsList" v-if="Array.isArray(newsList) && newsList.length !== 0">
                            <div class="Heziyun-itemNews" v-for="(item, index) in newsList" :key="item.id"
                                v-intersect="{ class: 'opacity', delay: index * 30 }">
                                <div class="Heziyun-newsDisplay">
                                    <!-- 标题 -->
                                    <a class="Heziyun-label"
                                        :href="`/${detailPath}/${item.id}.html`">
                                        <img src="@/static/img/new_Smell/lab.png" alt="">
                                        {{ item.title }}
                                    </a>
                                    <!-- 描述 -->
                                    <div class="Heziyun-flexall">
                                        <div class="Heziyun-time">
                                            <div class="Heziyun-timeIcon">
                                                <img src="@/static/img/new_Smell/time.svg" alt="">
                                                {{ getCurrentDate(item.create_time) }}
                                            </div>
                                            <div class="Heziyun-source">{{ addressID == '1' ?
                                                t('news.newsCenter') :
                                                t('news.announcementCenter') }}</div>
                                        </div>
                                        <a class="Heziyun-label2"
                                            :href="`/${detailPath}/${item.id}.html`">{{
                                                $t('news.newsDetails') }}<img src="@/static/img/new_Smell/right.svg"
                                                alt=""></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 暂无数据 -->
                        <a-empty v-else-if="newsList == null" v-intersect="{ class: 'opacity', delay: 0 }" />
                    </a-spin>
                </div>

                <!-- 分页 -->
                <div class="Heziyun-paging" v-if="Array.isArray(newsList) && newsList.length !== 0">
                    <div class="Heziyun-mainScore">
                        <a-pagination v-model:current="page" v-model:page-size="limit" :total="typeNum"
                            :page-size-options="['10', '20', '30', '50']" show-total show-page-size
                            @page-size-change="handlePageChanges" />
                    </div>
                    <!-- 共数据 -->
                    <div class="Heziyun-total">
                        {{ $t('news.totalData') }} <span>{{ typeNum }}</span> {{ $t('news.records') }}
                    </div>
                </div>
            </div>

            <RecentlyUpdated :detailscontent="t('news.newsAnnouncement')"></RecentlyUpdated>
        </div>
    </div>
</template>

<style>
@import "@/static/css/import";
@import "@/static/font/font.css";

body {
    background-color: #f5f7fc;
}
</style>

<style lang="less" scoped>
body {
    background-color: rgb(242, 243, 246) !important;
}

:deep(.arco-empty) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
}

:deep(.arco-spin) {
    width: 80%;
}

:deep(.arco-spin-mask) {
    backdrop-filter: blur(10px);
}

@font-face {
    font-family: "Title";
    font-weight: 400;
    src: url("@/static/font/file/AlimamaShuHeiTi-Bold.woff2") format("woff2");
    font-display: swap;
}

// banner图
.Heziyun-banners {
    background: url('@/static/img/new_Smell/banner.webp') no-repeat center;
    background-size: cover;
    position: relative;
    height: 20rem;
    margin-top: 3.6rem;
    padding: 0;

    .Heziyun-defaultWidth {
        position: relative;
        height: 100%;
        z-index: 2;

        .Heziyun-banner-title {
            p {
                text-align: left;
                color: #fff;
            }

            .Heziyun-buttonArray {
                display: flex;
                align-items: center;
                gap: 0.5rem;

                a {
                    border: 0.1rem solid #1D4ED8;
                }

                a:nth-of-type(2) {
                    background: #fff;
                    color: #1D4ED8;

                    &:hover {
                        background: #1D4ED8;
                        color: #fff;
                    }
                }

                a:nth-of-type(3) {
                    background: #fff;
                    color: #1D4ED8;

                    &:hover {
                        background: #1D4ED8;
                        color: #fff;
                    }
                }
            }
        }
    }

}

// 主分类
.Heziyun-mainCategory {
    .Heziyun-defaultWidth {
        display: flex;
        gap: 1.5rem;

        .Heziyun-flexmin {
            width: 75%;
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .Heziyun-sideEdge {
                display: flex;
                height: 100%;
            }

            // 主分类
            .Heziyun-hostList {
                display: flex;
                justify-content: space-between;
                width: 20%;

                .Heziyun-switchingClasses {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    font-family: "思源黑";
                    height: max-content;
                    position: sticky;
                    top: 4rem;
                    overflow-y: auto;
                    max-height: 38rem;

                    &::before {
                        content: "";
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 2px;
                        height: 100%;
                        background-color: rgb(232, 236, 243);
                    }

                    .Heziyun-itemClass {
                        padding: 0 0.5rem 0 1.5rem;
                        cursor: pointer;
                        line-height: 3rem;
                        max-width: 10rem;
                        min-width: 10rem;
                        height: 3rem;
                        border-right: 2px solid transparent;
                        font-weight: 700;
                        color: #4d4d4d;
                        position: relative;
                        z-index: 1;
                        font-family: math;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        flex-shrink: 0;

                        &::before {
                            content: '';
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            display: block;
                            width: 6px;
                            height: 6px;
                            background: linear-gradient(90deg, rgba(56, 96, 244, .21) 0, rgba(249, 250, 255, 0) 100%);
                            border-radius: 4px;
                        }

                        &:hover {
                            background: linear-gradient(90deg, rgba(235, 240, 252, 0) 0, #ebf0fc 100%);
                        }
                    }

                    .Heziyun-itemClass:not(:last-child) {
                        border-bottom: 1.5px solid rgb(237, 242, 251);
                    }

                    .Heziyun-active {
                        background: linear-gradient(to right, rgb(247, 248, 255), #fff);
                        border-right: 2px solid #0056ff;
                        color: #0056ff;

                        &::before {
                            background: linear-gradient(90deg, #0056ff 0, rgba(95, 135, 248, 0) 100%);
                        }

                        &:hover {
                            background: linear-gradient(to right, rgb(247, 248, 255), #fff);
                        }
                    }
                }

                /* Chrome/Safari/Edge等WebKit浏览器滚动条样式 */
                .Heziyun-switchingClasses::-webkit-scrollbar {
                    width: 3px;
                    height: 3px;
                    display: none;
                }

                .Heziyun-switchingClasses::-webkit-scrollbar-thumb {
                    background-color: #888;
                    border-radius: 2px;
                }

                .Heziyun-switchingClasses::-webkit-scrollbar-track {
                    background-color: transparent;
                }

                /* 确保所有滚动条按钮都被隐藏 */
                .Heziyun-switchingClasses::-webkit-scrollbar-button,
                .Heziyun-switchingClasses::-webkit-scrollbar-corner {
                    display: none;
                    width: 0;
                    height: 0;
                    background: transparent;
                }
            }

            @keyframes animate {
                0% {
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.91, 0.91) skew(0deg, 0.00deg);
                    opacity: 1.00;
                }

                4% {
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.91, 0.91);
                }

                8% {
                    animation-timing-function: cubic-bezier(0.69, 0.60, 0.35, 0.27);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.91, 0.91);
                }

                14% {
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.93, 0.93);
                }

                18% {
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.94, 0.94);
                }

                22% {
                    animation-timing-function: cubic-bezier(0.67, 0.66, 0.34, 0.33);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.96, 0.96);
                }

                26% {
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.97, 0.97);
                }

                30% {
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.99, 0.99);
                }

                34% {
                    animation-timing-function: cubic-bezier(0.65, 0.71, 0.32, 0.38);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(1.01, 1.01);
                }

                40% {
                    animation-timing-function: cubic-bezier(0.64, 0.74, 0.31, 0.41);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(1.02, 1.02);
                }

                46% {
                    animation-timing-function: cubic-bezier(0.60, 0.91, 0.23, 0.63);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(1.03, 1.03);
                }

                50% {
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(1.03, 1.03);
                }

                54% {
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(1.03, 1.03);
                }

                58% {
                    animation-timing-function: cubic-bezier(0.69, 0.60, 0.35, 0.27);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(1.03, 1.03);
                }

                64% {
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(1.01, 1.01);
                }

                68% {
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(1.00, 1.00);
                }

                72% {
                    animation-timing-function: cubic-bezier(0.67, 0.66, 0.34, 0.33);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.98, 0.98);
                }

                76% {
                    animation-timing-function: cubic-bezier(0.66, 0.68, 0.33, 0.35);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.97, 0.97);
                }

                82% {
                    animation-timing-function: cubic-bezier(0.65, 0.71, 0.32, 0.38);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.94, 0.94);
                }

                88% {
                    animation-timing-function: cubic-bezier(0.65, 0.73, 0.31, 0.40);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.92, 0.92);
                }

                94% {
                    animation-timing-function: cubic-bezier(0.63, 0.80, 0.28, 0.48);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.91, 0.91);
                }

                100% {
                    animation-timing-function: cubic-bezier(0.63, 0.80, 0.28, 0.48);
                    transform: translate(0.00px, 0.00px) rotate(0.00deg) scale(0.91, 0.91);
                }
            }

            /* 进场（enter）动画 */
            .dropdown-fade-enter-active {
                animation: opacity 0.4s ease;
                -webkit-animation: opacity 0.4s ease;
            }

            /* 出场（leave）动画 */
            .dropdown-fade-leave-active {
                animation: opacity 0.4s ease;
                -webkit-animation: opacity 0.4s ease;
            }

            // 新闻
            .Heziyun-newsList {
                display: flex;
                flex-direction: column;
                position: relative;
                border-radius: 2px;
                -webkit-border-radius: 2px;
                -moz-border-radius: 2px;
                -ms-border-radius: 2px;
                -o-border-radius: 2px;
                background: linear-gradient(1turn, #fff, #f7f9fd);
                border: 2px solid #fff;
                box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
                transition: none;
                -webkit-transition: none;
                -moz-transition: none;
                -ms-transition: none;
                -o-transition: none;
                height: max-content;

                .Heziyun-itemNews {
                    display: flex;
                    position: relative;
                    padding: 1rem 2rem;

                    &:hover {
                        background-color: #fff;

                        .Heziyun-newsDisplay {
                            .Heziyun-label {
                                color: rgb(55, 95, 242);
                            }
                        }
                    }

                    .Heziyun-newsDisplay {
                        display: flex;
                        flex-direction: column;
                        gap: 1rem;
                        position: relative;
                        z-index: 1;
                        width: 100%;

                        .Heziyun-label {
                            color: #181818;
                            font-weight: 700;
                            font-size: 0.95rem;
                            display: block;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            font-family: 'Title';

                            img {
                                width: 1.2rem;
                                margin-right: 1rem;
                            }
                        }

                        .Heziyun-flexall {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding-left: 2.4rem;

                            .Heziyun-time {
                                color: #181818;
                                font-size: 0.85rem;
                                display: flex;
                                align-items: center;
                                gap: 1rem;
                                font-family: "思源黑";
                                font-size: 0.7rem;

                                .Heziyun-timeIcon {
                                    display: flex;
                                    align-items: center;
                                    gap: 0.1rem;

                                    img {
                                        width: 0.8rem;
                                    }
                                }

                                .Heziyun-source {
                                    background-color: #0254ffb5;
                                    padding: 0.1rem 0.5rem;
                                    color: #fff;
                                    border-radius: 10rem;
                                    -webkit-border-radius: 10rem;
                                    -moz-border-radius: 10rem;
                                    -ms-border-radius: 10rem;
                                    -o-border-radius: 10rem;
                                    font-size: 0.6rem;
                                }
                            }

                            .Heziyun-label2 {
                                color: #3860f4;
                                font-size: 0.8rem;
                                width: max-content;

                                &:hover {
                                    filter: brightness(0.5);
                                }

                                img {
                                    width: 1.3rem;
                                }
                            }
                        }

                    }
                }

                .Heziyun-itemNews:not(:last-child) {
                    border-bottom: 1px solid #e9eef3;
                }


            }

            // 未
            .Heziyun-noData {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                min-height: 30rem;
                width: 100%;
                height: 100%;
                font-size: 1rem;

                img {
                    width: 15rem;
                }
            }
        }
    }
}

// 分页
.Heziyun-paging {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row-reverse;

    .Heziyun-total {
        display: flex;
        align-items: center;
        gap: 0.2rem;

        span {
            font-weight: bold;
            font-family: math;
            font-size: 2rem;
        }
    }
}


@media (max-width: 768px) {
    .Heziyun-banners {
        height: 50vw;
    }

    // 主分类
    .Heziyun-mainCategory {

        .Heziyun-defaultWidth {
            gap: 4vw;
            flex-direction: column;

            .Heziyun-flexmin {
                width: 100%;

                .Heziyun-sideEdge {

                    flex-direction: column;
                    gap: 4vw;

                    // 主分类
                    .Heziyun-hostList {
                        width: 100%;

                        .Heziyun-switchingClasses {
                            flex-wrap: initial;
                            overflow-y: auto;
                            flex-direction: row;
                            gap: 3vw;

                            &::before {
                                display: none;
                            }

                            .Heziyun-itemClass {
                                padding: 1.5vw 3.5vw;
                                flex-shrink: 0;
                                line-height: initial;
                                max-width: max-content;
                                min-width: max-content;
                                height: max-content;
                                border-right: none;
                            }

                            .Heziyun-itemClass:not(:last-child) {
                                border-bottom: none;
                            }

                            .Heziyun-active {
                                border-right: none;
                            }
                        }

                    }


                    :deep(.arco-spin) {
                        width: 100%;
                    }

                    // 新闻
                    .Heziyun-newsList {
                        gap: 3vw;
                        width: 100%;

                        .Heziyun-itemNews {
                            padding: 3vw;
                            border-radius: 1.5vw;
                            flex-direction: column;

                            .Heziyun-newsDisplay {
                                gap: 2vw;

                                .Heziyun-label {
                                    font-size: 4vw;

                                    img {
                                        width: 5vw;
                                        margin-right: 2vw;
                                    }
                                }

                                .Heziyun-flexall {
                                    padding-left: 7vw;
                                }

                                .Heziyun-label2 {
                                    font-size: 3.5vw;

                                    img {
                                        width: 6vw;
                                    }
                                }

                                .Heziyun-time {
                                    font-size: 3.2vw;
                                    gap: 3vw;

                                    .Heziyun-source {
                                        padding: 0.5vw 2vw;
                                        font-size: 3vw;
                                    }

                                    img {
                                        width: 3vw;
                                        height: 3vw;
                                    }
                                }
                            }
                        }


                    }

                    // 未
                    .Heziyun-noData {
                        min-height: 120vw;
                        font-size: 4.5vw;

                        img {
                            width: 70vw;
                        }
                    }
                }
            }
        }
    }

    // 分页
    .Heziyun-paging {
        flex-direction: column-reverse;
        gap: 5vw;
        padding-top: 5vw;

        .Heziyun-total {
            gap: 1vw;

            span {
                font-size: 7vw;
            }
        }
    }
}
</style>